import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-search-filter-field',
    imports: [FormsModule, ReactiveFormsModule, NgbTypeaheadModule],
    templateUrl: './search-filter-field.component.html',
    styleUrl: './search-filter-field.component.scss'
})
export class SearchFilterFieldComponent {
  @Input() form!: FormGroup;
  @Input() field: any = {};
  @Output() userSelected = new EventEmitter<any>();
  get isValid() { return this.form.controls[this.field.name].valid; }
  get isDirty() { return this.form.controls[this.field.name].dirty; }
  selectedData=''
  constructor(private cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
    console.log(this.field, '<---------input text----------->')
    this.form.valueChanges.subscribe((element) => {
      console.log(element)
    })
    this.cdr.detectChanges();
  }
  filteredOptions: any = [];
  showDropdown = false;
  ngOnChanges(data: any) {
    this.filteredOptions = this.field.options
    this.cdr.detectChanges();
  }
  filterOptions() {
    this.userSelected.emit(this.form.controls[this.field.name].value);
    // this.filteredOptions = this.field.options
    if(this.form.controls[this.field.name].value.length >3){
      this.filteredOptions =[]
    }
  }

  // onFocus() {
  //   this.filteredOptions = [...this.field.options]; // Show full list on focus
  //     this.filteredOptions = []
  // }



  selectOption(option: any) {
  
    this.form.get(this.field.name)?.setValue(option.name);
    this.filteredOptions = []
    this.showDropdown = false;
  }
}
